<template>
  <layout titlePage="Configurando seu site" :route="getRouterBack()">
    <progress
      class="progress onboarding-progress"
      :value="`${this.currentStepNumber}0`"
      max="100"
    ></progress>
    <div
      v-if="answerUser.wed_id"
      class="onboarding-create-site onboarding-create-site--steps"
    >
      <transition appear name="slide-fade" mode="in-out">
        <step1 v-if="showByStep(1)" :stepNumber="this.currentStepNumber + 1" />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step2
          v-if="showByStep(2)"
          :stepNumber="this.currentStepNumber + 1"
          :content="answerUser"
        />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step3 v-if="showByStep(3)" :stepNumber="this.currentStepNumber + 1" />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step4 v-if="showByStep(4)" :stepNumber="this.currentStepNumber + 1" />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step5 v-if="showByStep(5)" :stepNumber="this.currentStepNumber + 1" />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step6 v-if="showByStep(6)" :stepNumber="this.currentStepNumber + 1" />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step7 v-if="showByStep(7)" :stepNumber="this.currentStepNumber + 1" />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step8 v-if="showByStep(8)" :stepNumber="this.currentStepNumber + 1" />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step9 v-if="showByStep(9)" :stepNumber="this.currentStepNumber + 1"
      /></transition>
      <transition name="slide-fade" mode="in-out">
        <step10 v-if="showByStep(10)" />
      </transition>
      <transition name="slide-fade" mode="in-out">
        <step11 v-if="showByStep(11)" />
      </transition>
    </div>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'

import step1 from '@/components/OnboardingCreationSite/Step1.vue'
import step2 from '@/components/OnboardingCreationSite/Step2.vue'
import step3 from '@/components/OnboardingCreationSite/Step3.vue'
import step4 from '@/components/OnboardingCreationSite/Step4.vue'
import step5 from '@/components/OnboardingCreationSite/Step5.vue'
import step6 from '@/components/OnboardingCreationSite/Step6.vue'
import step7 from '@/components/OnboardingCreationSite/Step7.vue'
import step8 from '@/components/OnboardingCreationSite/Step8.vue'
import step9 from '@/components/OnboardingCreationSite/Step9.vue'
import step10 from '@/components/OnboardingCreationSite/Step10.vue'
import step11 from '@/components/OnboardingCreationSite/Step11.vue'

export default {
  components: {
    layout,
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
    step7,
    step8,
    step9,
    step10,
    step11,
  },

  computed: {
    wedId() {
      return this.$store.getters['app/getWedId']
    },

    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    currentStepNumber() {
      const stepNumber = this.$route.params.id.split('-')
      return parseInt(stepNumber[1])
    },
  },

  watch: {
    wedId(payload) {
      if (payload) {
        this.getWedsiteData()
        this.$set(this.answerUser, 'wed_id', parseInt(this.wedId))
      }
    },
  },

  mounted() {
    if (this.wedId) {
      this.$set(this.answerUser, 'wed_id', parseInt(this.wedId))
      this.getWedsiteData()
    }
  },

  metaInfo: {
    title: 'Configurando seu site',
  },

  methods: {
    getRouterBack() {
      const route = this.currentStepNumber

      if (route === 3 || route === 6 || route === 11) {
        return {
          path: '/onboarding/passo-' + (route - 2),
        }
      }
      if (route !== 1) {
        return {
          path: '/onboarding/passo-' + (route - 1),
        }
      }
      return { name: 'onboarding' }
    },

    getWedsiteData() {
      this.mySiteInfo = this.wedSiteInfo

      if (this.mySiteInfo) {
        const result = this.mySiteInfo.site_url.split('/')
        this.answerUser.wed_id = parseInt(this.wedId)
        this.answerUser.step8 = result[3]
      }
    },

    showByStep(step) {
      return this.currentStepNumber == step
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &--steps {
    margin-top: 0px;
  }
}

.onboarding-progress {
  height: 8px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0;
  margin: 0 !important;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(2, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(20px);
  opacity: 0;
}
</style>
